import { EditorState, Modifier, SelectionState } from 'draft-js';
import { getSelectedBlocks } from 'lib/helpers';

/**
 * 如果 block 是 Atomic Block，获取其渲染所用的 props
 * @param {Draft.ContentBlock} block
 * @param {DraftEditorStore} store
 */
export function getAtomicFocusableProps(block, store) {
	// 提供 Atomic Block 的焦点支持
	const focused = getSelectedBlocks(store.getEditorState()).contains(block); // o(n)
	const onFocus = () => {
		const editorState = store.getEditorState();
		const selection = SelectionState.createEmpty(block.getKey()).merge({
			anchorOffset: 0,
			focusOffset: block.getLength(),
		});
		store.setEditorState(EditorState.set(editorState, { selection }));
		window.getSelection().removeAllRanges();
	};

	return {
		focused,
		onFocus,
	};
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/focusPlugin/getAtomicFocusableProps.js